import { useState } from "react";
import APIS from "../../constant/EndPoint";
import AutoFillComboboxInput from "../Reusable/AutoFillComboboxInput";
import LocationCombobox from "../Reusable/Combobox";
import ComboboxInput from "../Reusable/ComboboxInput";
import ProductTypeComboboxInput from "../Reusable/ProductTypeComboBox";
import PaymentMethodCombobox from "../Reusable/PaymentMethodBox";
import TextField from "../Reusable/TextField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useWatch } from "react-hook-form";
import Modal from "../Reusable/Modal";
import InfoIcon from "../../Icons/InfoIcon";

const OrderForm = ({
  errors,
  register,
  setValue,
  getValues,
  clearErrors,
  fields,
  watch,
  remove,
  setReceiverId,
  append,
  control,
  currentMerchantProfile,
}: any) => {
   const [coveredArea, setCoveredArea] = useState("");
  const [infoOpen, setInfoOpen] = useState(false);
  const destination = useWatch({
    control: control,
    name: "destination",
  });
  return (
    <>
      <div className={tw`w-full grid grid-cols-2 gap-x-4 px-4`}>
        <>
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"barnch"}
            register={register("pickup_branch", {
              required: "Pickup branch is required",
            })}
            errors={errors?.pickup_branch}
            name={"pickup_branch"}
            label={"From"}
            props={{ is_active: true }}
            setValue={setValue}
            getValues={getValues}
            placeholder={"Search Pickup Branch"}
            clearErrors={clearErrors}
          />
          <div className={tw`relative w-full flex flex-col`}>
            <LocationCombobox
              url={APIS.DESTINATION}
              props={{ level: 3, is_active: true }}
              queryKey={"location"}
              register={register(`destination` as const, {
                required: "Destination city is required",
              })}
              errors={errors?.destination}
              name={"destination"}
              label={"Destination"}
              setValue={setValue}
              getValues={getValues}
              placeholder={"Search Destination City"}
              clearErrors={clearErrors}
              onSelect={(location: any) => {
                setCoveredArea(
                  location.covered_area ||
                    location.parent?.covered_area ||
                    "Not available"
                );
              }}
            />
            {destination && (
              <button
                type="button"
                onClick={() => setInfoOpen(true)}
                className={tw`absolute right-[3.5rem] top-[77%] -translate-y-1/2  rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 focus:outline-none`}
                title="Show Covered Area"
              >
                <InfoIcon />
              </button>
            )}
          </div>
          <Modal isOpen={infoOpen} setIsOpen={setInfoOpen} title="Covered Area">
            <div className={tw`p-4 w-full mx-auto`}>
              <p className={tw`text-gray-800 mt-4 text-lg`}>{coveredArea}</p>
            </div>
          </Modal>
        </>
      </div>
      <div>
        <div
          className={tw`w-full mt-6 flex justify-left px-4 gap-x-2 uppercase font-extrabold items-center`}
        >
          <span className={tw`text-[#5E5757] font-bold text-sm`}>
            Receiver Informations
          </span>
        </div>
        <div className={tw`w-full grid grid-cols-4 gap-x-4 px-4`}>
          <div className={tw`w-full `}>
            <AutoFillComboboxInput
              url={APIS.CUSTOMER}
              queryKey={"customer"}
              register={register("receiver_full_name" as const, {
                required: "Receiver Name is required",
              })}
              errors={errors?.receiver_full_name}
              props={{
                is_active: true,
              }}
              name={`receiver_full_name`}
              label={"Full Name"}
              watch={watch}
              setValue={setValue}
              setSenderId={setReceiverId}
              placeholder={"Search Receiver"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </div>
          <TextField
            label={"Address"}
            register={register("receiver_address" as const, {
              required: "Receiver address is required",
            })}
            errors={errors?.receiver_address}
          />
          {/* <PhoneNumberField
            control={control}
            label={'Phone Number'}
            name={'receiver_phone_number'}
            errors={errors?.receiver_phone_number}
          /> */}
          <TextField
            label={"Phone Number"}
            register={register("receiver_phone_number" as const, {
              required: "Receiver phone number is required",
            })}
            errors={errors?.receiver_phone_number}
          />
          <TextField
            label={"VAT/PAN"}
            register={register("receiver_vat_pan")}
            errors={errors?.receiver_vat_pan}
          />
        </div>
      </div>
      <div>
        <div
          className={tw`w-full mt-6 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center`}
        >
          <div className={tw`text-[#5E5757] font-bold text-sm`}>
            Shipment Informations
          </div>
        </div>
        <div className={tw`w-full grid grid-cols-2 gap-x-4 px-4`}>
          <ComboboxInput
            url={APIS.SERVICE_TYPE}
            queryKey={"service-type"}
            register={register("service_type" as const, {
              required: "Service Type is required",
            })}
            errors={errors?.service_type}
            name={"service_type"}
            props={{
              is_active: true,
            }}
            label={"Service Type"}
            setValue={setValue}
            placeholder={"Search Service Type"}
            getValues={getValues}
            clearErrors={clearErrors}
          />

          <PaymentMethodCombobox
              paymentMethods={currentMerchantProfile?.payment_method ?? []}
              name="payment_method"
              label="Payment Method"
              placeholder="Select Payment Method"
              setValue={setValue}
              getValues={getValues}
              clearErrors={clearErrors}
              errors={errors?.payment_method}
          />
        </div>
      </div>
      <hr className={tw`mt-6`} />
      <div>
        {fields.map((field: any, index: any) => {
          return (
            <div key={index}>
              <div
                className={tw`relative w-full mt-2 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center`}
              >
                <div className={tw`text-[#5E5757] font-bold text-xs`}>
                  Order {index + 1}
                </div>
                <button
                  type="button"
                  className={tw`rounded p-1 m-1 border border-gray-400 text-xs`}
                  disabled={index === 0 ? true : false}
                  onClick={() => remove(index)}
                >
                  Remove ({index + 1})
                </button>
              </div>
              <div className={tw`w-full grid grid-cols-4 gap-x-4 px-4`}>
                <TextField
                  label={"Product Description"}
                  register={register(`order_items.${index}.remark` as const)}
                  errors={errors.remark}
                />
                <ProductTypeComboboxInput
                  url={APIS.PRODUCT_TYPE}
                  queryKey={"product-type"}
                  register={register(
                    `order_items.${index}.package_type` as const,
                    {
                      required: "Product Type is required",
                    }
                  )}
                  errors={errors?.order_items?.[index]?.package_type}
                  name={`order_items.${index}.package_type`}
                  is_rate_by_weight={`order_items.${index}.is_rate_by_weight`}
                  label={"Product Type"}
                  setValue={setValue}
                  props={{ is_active: true }}
                  placeholder={"Search Product Type"}
                  getValues={getValues}
                  clearErrors={clearErrors}
                  value={getValues()["order_items"][index]["package_type"]}
                />
                <TextField
                  label={"Pcs."}
                  register={register(`order_items.${index}.piece` as const, {
                    required: "Piece is required",
                    valueAsNumber: true,
                    min: {
                      value: 1,
                      message: "Piece must be at least 1",
                    },
                    validate: (value) =>
                      !isNaN(value) || "Piece must be a number",
                  })}
                  errors={errors?.order_items?.[index]?.piece}
                />
                <TextField
                  label={"Weight(Kg)"}
                  register={register(`order_items.${index}.weight` as const, {
                    required: "Weight is required",
                    valueAsNumber: true,
                    validate: (value) =>
                      !isNaN(value) || "Weight must be a number",
                  })}
                  errors={errors?.order_items?.[index]?.weight}
                />
              </div>
            </div>
          );
        })}
        <div className={tw`w-full flex justify-end px-4`}>
          <button
            type="button"
            className={tw`rounded p-1 m-1 border border-gray-400 text-xs`}
            onClick={() =>
              append({
                product_type: null,
                piece: 1,
                weight: 1,
                rate: 0,
              })
            }
          >
            Add Product
          </button>
        </div>
        <hr />
      </div>
      <div className={tw`w-full grid grid-cols-4 gap-x-2 px-4`}>
        <ComboboxInput
          url={APIS.REFERENCE_TYPE}
          queryKey={"reference-type"}
          register={register(`reference_type`)}
          errors={errors?.reference_type}
          name={"reference_type"}
          label={"Document Type"}
          props={{
            is_active: true,
          }}
          setValue={setValue}
          getValues={getValues}
          placeholder={"Search Document Type"}
          clearErrors={clearErrors}
        />
        <TextField
          label={"Doc. Number"}
          placeholder={"Doc. Number"}
          register={register(`reference_number`)}
          errors={errors?.reference_number}
        />
        <TextField
          type="date"
          label={"Document Date"}
          register={register(`reference_date` as const, {
            required: false,
          })}
          errors={errors?.reference_date}
        />
        <TextField
          type="text"
          label={"Goods Value"}
          register={register(`order_value` as const, {
            required: false,
          })}
          errors={errors?.reference_date}
        />
        <TextField
          label={"Remarks"}
          register={register(`note` as const, {
            required: false,
          })}
          errors={errors?.note}
        />
      </div>
    </>
  );
};

export default OrderForm;
